<template>
<div class="chapter">
<div class="inner_page">
<p class="txt">Let’s say there had not been a Merle Kilgore. There would have been a big empty spot in [the Country Music] business. He contributed songs; he contributed his knowledge and his friendship in bringing people together. This business is pretty big, but his footprint is over a considerable part of it. His association with Hank Williams, and Hank Williams, Jr., and Johnny Cash—he helped those people. They owed a lot to Merle, and they knew it.</p>
<p class="txr"><b>Ralph Emery</b></p>
<p class="tx2">Merle was more to me than a manager. He was a father figure, he was a mentor, he was my business advisor; but most of all, Merle Kilgore was my best friend<sup><span href="#/notes#fm1_nt1" id="fm1_ft1" title="Link target outside of Sample">1</span></sup>.</p>
<p class="txr"><b>Hank Williams, Jr.</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?66a0b6ce